import { _ as _defineProperty } from '../../defineProperty-377d5a7f.js';
import { _ as _asyncToGenerator, r as regenerator } from '../../index-33ee6c9f.js';
import { _ as _createClass, a as _classCallCheck } from '../../createClass-70c51ca1.js';
import { ReCaptchaActionOptions } from '../constants/index.js';
import { USER_KEY_COOKIE_NAME, USER_KEY_HEADER_DISABLED, RequestHeaders, API_URL, SOCIAL_REQUEST_HEADER_TOKEN } from '../../configs/constants/index.js';
import IS_BROWSER from '../../isBrowser/index.js';
import isDev from '../../isDev/index.js';
import extractUserInfo from '../../profile/index.js';
import getReCaptchaToken from '../../getReCaptchaToken/index.js';
import { getCookie } from '../../cookie/index.js';
import HttpService from '../http/index.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var DEFAULT_BASE_PATH = '/';

/**
 * This method generates object, which contains header for authorization
 * @param accessToken access token, which will generated to { Authorization: `Bearer <accessToken>` } object
 * @param tokenHeader token header, which will generate to { Authorization: tokenHeader } object. It is contains access token and Bearer together.
 * @returns header object for authorization
 */
var authorizationHeader = function authorizationHeader(accessToken, tokenHeader) {
  var header = {
    platform: 'website'
  };
  var userKey = getCookie(USER_KEY_COOKIE_NAME);
  if (!USER_KEY_HEADER_DISABLED && userKey) {
    header[RequestHeaders.xApiKey] = userKey;
  }
  if (accessToken) {
    header.Authorization = "Bearer ".concat(accessToken);
  }
  if (tokenHeader) {
    header.Authorization = tokenHeader;
  }
  return header;
};
var AuthService = /*#__PURE__*/function () {
  function AuthService() {
    _classCallCheck(this, AuthService);
  }
  _createClass(AuthService, [{
    key: "signIn",
    value: function () {
      var _signIn = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(username, password, recaptchaToken, preventReCaptcha, currentLanguage) {
        var headers, signinResponse, userInfo;
        return regenerator.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              headers = {
                platform: 'website',
                'g-recaptcha-token': recaptchaToken,
                'g-recaptcha-action': 'signIn',
                token: SOCIAL_REQUEST_HEADER_TOKEN
              };
              if (preventReCaptcha) {
                headers['language-code'] = currentLanguage;
              }
              _context.prev = 2;
              _context.next = 5;
              return HttpService.post("".concat(API_URL, "/user-account/signin.json"), {
                username: username,
                password: password,
                recaptchaToken: recaptchaToken,
                isLocal: isDev
              }, {
                headers: headers
              });
            case 5:
              signinResponse = _context.sent;
              _context.next = 8;
              return extractUserInfo(_objectSpread(_objectSpread({}, signinResponse), {}, {
                registered: false
              }));
            case 8:
              userInfo = _context.sent;
              return _context.abrupt("return", _objectSpread(_objectSpread({}, signinResponse), {}, {
                status: signinResponse.status,
                user: userInfo,
                removal_info: signinResponse.removal_info
              }));
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](2);
              console.error('err', _context.t0);
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 12]]);
      }));
      function signIn(_x, _x2, _x3, _x4, _x5) {
        return _signIn.apply(this, arguments);
      }
      return signIn;
    }()
  }, {
    key: "signUp",
    value: function () {
      var _signUp = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(email, password, recaptchaToken, hasConsent) {
        var headers, signupResponse, userInfo;
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              headers = {
                platform: 'website',
                'g-recaptcha-token': recaptchaToken,
                'g-recaptcha-action': 'signUp',
                token: SOCIAL_REQUEST_HEADER_TOKEN
              };
              _context2.next = 3;
              return HttpService.post("".concat(API_URL, "/user-account/signup.json"), {
                email: email,
                password: password,
                isLocal: isDev,
                recaptchaToken: recaptchaToken,
                email_subscription_consent: hasConsent
              }, {
                headers: headers
              });
            case 3:
              signupResponse = _context2.sent;
              _context2.next = 6;
              return extractUserInfo(_objectSpread(_objectSpread({}, signupResponse), {}, {
                registered: true
              }));
            case 6:
              userInfo = _context2.sent;
              return _context2.abrupt("return", _objectSpread(_objectSpread({}, signupResponse), {}, {
                status: signupResponse.status,
                user: userInfo,
                removal_info: signupResponse.removal_info
              }));
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function signUp(_x6, _x7, _x8, _x9) {
        return _signUp.apply(this, arguments);
      }
      return signUp;
    }()
  }, {
    key: "updateUsername",
    value: function updateUsername(username) {
      var basePath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_BASE_PATH;
      return HttpService.post("".concat(basePath, "update-username"), {
        username: username
      });
    }
  }, {
    key: "validateUsername",
    value: function validateUsername(username) {
      var basePath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_BASE_PATH;
      return HttpService.post("".concat(basePath, "validate-username"), {
        username: username
      });
    }
  }, {
    key: "fetchUser",
    value: function fetchUser(accessToken, options) {
      var basePath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_BASE_PATH;
      var _ref = options || {},
        _ref$headers = _ref.headers,
        headers = _ref$headers === void 0 ? {} : _ref$headers;
      return HttpService.get("".concat(basePath, "user"), _objectSpread({
        headers: headers
      }, authorizationHeader(accessToken)));
    }
  }, {
    key: "fetchAppleUser",
    value: function fetchAppleUser(data) {
      var basePath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_BASE_PATH;
      return HttpService.post(basePath, data);
    }
  }, {
    key: "sendConfirmationEmail",
    value: function sendConfirmationEmail(user, email) {
      var basePath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_BASE_PATH;
      return HttpService.post("".concat(basePath, "send-confirmation-email"), {
        user: user,
        email: email,
        confirmation_email_redirect_url: window.location.href
      });
    }

    // TODO remove after registration with forced email verification's A/B test.
  }, {
    key: "setUserTemporaryCookies",
    value: function setUserTemporaryCookies(created, userId) {
      if (IS_BROWSER) {
        var expires = new Date(Date.parse(created) + 24 * 60 * 60 * 1000);
        document.cookie = "user_temporary_".concat(userId, "=user_temporary_").concat(userId, "; expires=").concat(expires);
        document.cookie = "forcedExperimentVariant=1; expires=".concat(expires);
        return true;
      }
      return false;
    }

    // TODO remove after registration with forced email verification's A/B test.
  }, {
    key: "extractTemporaryUserInfo",
    value: function extractTemporaryUserInfo(userInfo) {
      if (!userInfo) {
        return {};
      }
      var id = userInfo.id,
        created = userInfo.created;
      return {
        created: created,
        id: id
      };
    }

    // TODO remove after registration with forced email verification's A/B test.
  }, {
    key: "userStatusCheck",
    value: function userStatusCheck(userInfo) {
      if (!userInfo) {
        return false;
      }
      var isUserTemporary = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.account_type) === 'temporary';
      if (isUserTemporary) {
        var _this$extractTemporar = this.extractTemporaryUserInfo(userInfo),
          id = _this$extractTemporar.id,
          created = _this$extractTemporar.created;
        id && created && this.setUserTemporaryCookies(created, id);
      }
      return isUserTemporary;
    }
  }, {
    key: "resendEmailRequest",
    value: function resendEmailRequest(_ref2) {
      var email = _ref2.email,
        accessToken = _ref2.accessToken;
      var body = email ? {
        email: email
      } : {};
      return getReCaptchaToken(ReCaptchaActionOptions.ResendEmailRequest).then(function (_ref3) {
        var status = _ref3.status,
          token = _ref3.token;
        return status === 'success' && HttpService.get("".concat(API_URL, "/user-account/activation?confirmation_email_redirect_url=").concat(window.location.href), _objectSpread(_objectSpread({}, body), {}, {
          headers: _objectSpread(_objectSpread({
            'g-recaptcha-token': token,
            'g-recaptcha-action': ReCaptchaActionOptions.ResendEmailRequest
          }, authorizationHeader(accessToken)), {}, {
            platform: 'website'
          })
        }));
      });
    }
  }, {
    key: "checkUserExistence",
    value: function () {
      var _checkUserExistence = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(email) {
        var encodedEmail, res, reason;
        return regenerator.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              encodedEmail = encodeURIComponent(email.toLowerCase());
              _context3.prev = 1;
              _context3.next = 4;
              return getReCaptchaToken(ReCaptchaActionOptions.UserExistence).then(function (_ref4) {
                var status = _ref4.status,
                  token = _ref4.token;
                if (status === 'success') {
                  return HttpService.get("".concat(API_URL, "/users/email/existence?email_encoded=1&emails=").concat(encodedEmail), {
                    headers: {
                      'g-recaptcha-token': token,
                      'g-recaptcha-action': ReCaptchaActionOptions.UserExistence
                    }
                  });
                }
              });
            case 4:
              res = _context3.sent;
              return _context3.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
                status: res.status
              }));
            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](1);
              reason = '';
              if (_context3.t0.message === 'Failed to fetch') {
                reason = 'Internet Connection';
              }
              return _context3.abrupt("return", {
                status: 'error',
                response: _context3.t0,
                reason: reason
              });
            case 13:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[1, 8]]);
      }));
      function checkUserExistence(_x10) {
        return _checkUserExistence.apply(this, arguments);
      }
      return checkUserExistence;
    }()
  }, {
    key: "checkUsernameExistence",
    value: function () {
      var _checkUsernameExistence = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4(username) {
        var res, reason;
        return regenerator.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return getReCaptchaToken(ReCaptchaActionOptions.UsernameExistence).then(function (_ref5) {
                var status = _ref5.status,
                  token = _ref5.token;
                if (status === 'success') {
                  return HttpService.post("".concat(API_URL, "/users/validate/username"), {
                    headers: {
                      'g-recaptcha-token': token,
                      'g-recaptcha-action': ReCaptchaActionOptions.UsernameExistence
                    },
                    username: username.toLowerCase()
                  });
                }
              });
            case 3:
              res = _context4.sent;
              return _context4.abrupt("return", _objectSpread({}, res));
            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4["catch"](0);
              reason = '';
              if (_context4.t0.message === 'Failed to fetch') {
                reason = 'Internet Connection';
              }
              return _context4.abrupt("return", {
                status: 'error',
                response: _context4.t0,
                reason: reason
              });
            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 7]]);
      }));
      function checkUsernameExistence(_x11) {
        return _checkUsernameExistence.apply(this, arguments);
      }
      return checkUsernameExistence;
    }()
  }]);
  return AuthService;
}();
var authService = new AuthService();
var setUserTemporaryCookies = authService.setUserTemporaryCookies,
  extractTemporaryUserInfo = authService.extractTemporaryUserInfo,
  userStatusCheck = authService.userStatusCheck,
  resendEmailRequest = authService.resendEmailRequest,
  signIn = authService.signIn,
  signUp = authService.signUp,
  fetchUser = authService.fetchUser,
  fetchAppleUser = authService.fetchAppleUser,
  sendConfirmationEmail = authService.sendConfirmationEmail,
  updateUsername = authService.updateUsername,
  validateUsername = authService.validateUsername,
  checkUserExistence = authService.checkUserExistence,
  checkUsernameExistence = authService.checkUsernameExistence;

export { AuthService, authService, authorizationHeader, checkUserExistence, checkUsernameExistence, extractTemporaryUserInfo, fetchAppleUser, fetchUser, resendEmailRequest, sendConfirmationEmail, setUserTemporaryCookies, signIn, signUp, updateUsername, userStatusCheck, validateUsername };
//# sourceMappingURL=index.js.map
